const normalizeString = (value, fallback = '') => {
  const normalized = String(value || '').trim();
  return normalized || fallback;
};

const normalizeRoutePrefix = (value, fallback = '/pam') => {
  const raw = normalizeString(value, fallback);
  const withLeadingSlash = raw.startsWith('/') ? raw : `/${raw}`;
  return withLeadingSlash.replace(/\/+$/, '') || fallback;
};

export const APP_CONFIG = {
  apiBaseUrl: normalizeString(import.meta.env.VITE_API_BASE_URL, 'https://api.uat.gplaygap.com'),
  operator: normalizeString(import.meta.env.VITE_OPERATOR, 'GPTEST'),
  pamRoutePrefix: normalizeRoutePrefix(import.meta.env.VITE_PAM_ROUTE_PREFIX, '/pam'),
  gamePlaceholderImage: '/img/game-placeholder.svg',
};

export const STORAGE_KEYS = {
  token: 'pam_access_token',
  player: 'pam_player',
};
